import { Euro, FileCheck, Home, Calculator } from "lucide-react";

const PrimesSection = () => {
  return (
    <section id="primes" className="py-20 md:py-28 bg-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <Euro className="w-4 h-4" />
            Aides financières disponibles
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            Primes Région Wallonne 2025-2026
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Bénéficiez des aides de la Région Wallonne pour vos travaux de toiture et d'isolation. 
            Nous vous accompagnons dans toutes vos démarches.
          </p>
        </div>

        {/* Primes Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-green-100">
            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4">
              <Euro className="w-6 h-6 text-green-600" />
            </div>
            <h3 className="font-heading font-semibold text-slate-900 mb-2">Jusqu'à 120€/m²</h3>
            <p className="text-sm text-slate-600">Pour l'isolation de toiture avec isolant standard (selon revenus)</p>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-sm border border-green-100">
            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4">
              <FileCheck className="w-6 h-6 text-green-600" />
            </div>
            <h3 className="font-heading font-semibold text-slate-900 mb-2">Sans audit obligatoire</h3>
            <p className="text-sm text-slate-600">Pour les travaux de toiture et isolation du toit</p>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-sm border border-green-100">
            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4">
              <Home className="w-6 h-6 text-green-600" />
            </div>
            <h3 className="font-heading font-semibold text-slate-900 mb-2">Logement +15 ans</h3>
            <p className="text-sm text-slate-600">Votre habitation doit avoir au moins 15 ans pour être éligible</p>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-sm border border-green-100">
            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4">
              <Calculator className="w-6 h-6 text-green-600" />
            </div>
            <h3 className="font-heading font-semibold text-slate-900 mb-2">Jusqu'à 70%</h3>
            <p className="text-sm text-slate-600">Des travaux remboursés selon votre catégorie de revenus</p>
          </div>
        </div>

        {/* CTA Box */}
        <div className="bg-white rounded-2xl p-8 md:p-10 shadow-lg border border-green-200">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-slate-900 mb-2">
                Nous gérons vos démarches de primes
              </h3>
              <p className="text-slate-600">
                Notre équipe vous accompagne gratuitement dans la constitution de votre dossier de prime Wallonie.
              </p>
            </div>
            <a
              href="#form"
              className="flex-shrink-0 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-full font-semibold transition-all duration-300 hover:-translate-y-1 shadow-lg shadow-green-600/25"
              data-testid="primes-cta-button"
            >
              Vérifier mon éligibilité
            </a>
          </div>
        </div>

        {/* Info Text */}
        <p className="text-center text-sm text-slate-500 mt-8">
          * Montants indicatifs selon le régime des primes habitation 2025-2026. 
          Les montants exacts dépendent de votre catégorie de revenus et du type d'isolant utilisé.
        </p>
      </div>
    </section>
  );
};

export default PrimesSection;
